import classNames from 'classnames';

import { Grid } from '../../../grid/grid';
import { ImageEmbedded, ImageEmbeddedProps } from '../../../image/image-embedded';
import { Text } from '../../../text/text.component';
import { WistiaVideoProps } from '../../../wistia-video/wistia-video.config';
import { withAsyncImport } from '../../../../utils/with-async-import';

import { QuoteProps } from './quote';
import { QuoteCarouselItemQuoter } from '../quote-carousel-item-quoter/quote-carousel-item-quoter';

import './quote.scss';

const WistiaVideo = withAsyncImport<WistiaVideoProps>(
  () => import(/* webpackChunkName: "components" */ '../../../wistia-video/wistia-video.component')
);

export interface QuoteWithImageProps extends QuoteProps {
  image?: ImageEmbeddedProps;
  video?: WistiaVideoProps;
}

export const QuoteWithMedia = ({ image, video, logo, quote, person, titleOfPerson }: QuoteWithImageProps) => {
  const getQuoteMark = (isInline?: boolean) =>
    `<p class=${classNames({ 'snowflake-quote-mark-inline': isInline, 'snowflake-quote-mark': !isInline })}>${
      isInline ? '”' : '“'
    }</p>`;

  const getQuoteTag = (quoteText: string) =>
    `<div class="snowflake-quote-tag">${getQuoteMark()}<div>${quoteText}${getQuoteMark(true)}</div></div>`;

  return (
    <div
      data-testid="snowflake-quote-carousel-item-with-media"
      className="snowflake-quote-carousel-item snowflake-quote-carousel-item-with-media snowflake-container"
    >
      <Grid container>
        {(image || video) && (
          <Grid item mobile={12} tablet={12} smallDesktop={6} desktop={6}>
            {image && (
              <div
                data-testid="snowflake-quote-carousel-item-image"
                className="snowflake-quote-carousel-item-media-wrapper"
              >
                <ImageEmbedded {...image} baseCssClass="cmp-image" />
              </div>
            )}
            {video && (
              <div
                data-testid="snowflake-quote-carousel-item-video"
                className="snowflake-quote-carousel-item-media-wrapper"
              >
                <WistiaVideo {...video} />
              </div>
            )}
          </Grid>
        )}
        <Grid item mobile={12} tablet={12} smallDesktop={6} desktop={6}>
          <Grid container className="snowflake-quote-carousel-item-right-info-box-wrapper">
            <Grid item mobile={12} tablet={12} smallDesktop={9} desktop={10}>
              <Grid container className="snowflake-quote-carousel-item-right-info-box">
                {quote && (
                  <Grid item tablet={6}>
                    <div
                      data-testid="snowflake-quote-carousel-item-with-image-quote-text"
                      className="snowflake-quote-carousel-item-right-info-box-text"
                    >
                      <Text {...quote} text={getQuoteTag(quote.text as string)} />
                    </div>
                  </Grid>
                )}
                <Grid item mobile={12} tablet={6}>
                  <Grid container className="snowflake-quote-carousel-item-quoter-grid-wrapper">
                    <Grid item className="snowflake-quote-carousel-item-quoter-grid">
                      <QuoteCarouselItemQuoter
                        isOnImageCarousel
                        logo={logo}
                        person={person}
                        titleOfPerson={titleOfPerson}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
